import { DependencyList, useMemo } from "react";

type QueryToConditionsConverter<T> = (
  conditions: SearchCondition<T>[],
) => SearchCondition<T>[];

export interface SearchCondition<T> {
  key: keyof T;
  label: string;
  value: string;
}

export interface SearchConditionResponse<T> {
  conditions: SearchCondition<T>[];
  hasCondition: boolean;
}

const useSearchCondition = <T>(
  converter: QueryToConditionsConverter<T>,
  depth: DependencyList,
): SearchConditionResponse<T> => {
  const conditions = useMemo<SearchCondition<T>[]>(() => {
    return converter([]);
  }, depth);

  const hasCondition = useMemo<boolean>(() => {
    return conditions.length > 0;
  }, [conditions]);

  return {
    conditions,
    hasCondition,
  };
};

export default useSearchCondition;
